const API_BASE_URL = process.env.REACT_APP_BASE_API_URL;

function getToken() {
    const raw = localStorage.getItem("token") || "";
    return raw.startsWith("Bearer ") ? raw.slice(7) : raw;
}

export const getLeadChatApi = async (leadId, role, page = 1, perPage = 50) => {
    const token = getToken();

    try {
        const response = await fetch(
            `${API_BASE_URL}/${role}/lead/leads/${leadId}/chat?page=${page}&per_page=${perPage}`,
            {
                method: "GET",
                headers: {
                    Accept: "application/json",
                    Authorization: `Bearer ${token}`,
                },
            }
        );

        if (!response.ok) {
            const errorData = await response.json();
            throw { ...errorData, statusCode: response.status };
        }

        const result = await response.json();

        // expected backend:
        // { chat: {...}, messages: { data: [...], meta: { page, per_page, total, last_page } } }
        const messages = result?.messages || {};
        const meta = messages?.meta || {};

        return {
            chat: result?.chat || null,
            data: Array.isArray(messages?.data) ? messages.data : [],
            meta: {
                total_count: meta?.total ?? 0,
                current_page: meta?.current_page ?? meta?.page ?? page,
                per_page: meta?.per_page ?? perPage,
                total_pages: meta?.last_page ?? 1,
            },
        };
    } catch (error) {
        console.error("[getLeadChatApi] Error:", error);
        throw error;
    }
};
